export const enrichDefaultCampaignData = (data) => {
    return {
        utm_campaign: data.utm_campaign || (data['~campaign'] ? '' : 'organic_seo'),
        ['~campaign']: data['~campaign'] || 'organic_seo',
        ...data,
    };
};
